import NsContent from 'components/common/ns-content/NsContent';
import NsColumn from '@britishgasenergy/react-nucleus/dist/nuc-components/NsColumn';

import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsSecondaryCta } from 'components/common/ns-secondary-cta/NsSecondaryCta';
import { actionUrl } from 'config/static-content';
import { NsCard } from 'components/common/ns-card/NsCard';
import { useNavigation } from 'hooks/useNavigation';
import { Feature } from 'components/common/feature/Feature';
import { ToggleJourney } from 'components/app/routes/ToggleJourney';
import { useAllowJourney } from 'hooks/useAllowJourney';

export const testId = 'businessAnnouncementTestId';

export const BusinessAnnouncement = () => {
  const allowJourney = useAllowJourney();
  const { eventTypes, next } = useNavigation();

  const handleGoNext = () => {
    next({ eventType: eventTypes.NEXT });
  };

  return (
    <Feature feature={!allowJourney} inactiveComponent={<ToggleJourney on />}>
      <NsPanel testId={testId}>
        <NsContent>
          <NsTitle title="Please come back later" />
          <p>
            We&apos;re working on some updates to our website right now, so
            you&apos;ll need to come back later.
          </p>
          <p>
            We&apos;d be happy to email you with a handy link, so you can easily
            get a quote when it&apos;s available again.
          </p>
          <NsPrimaryCta onClick={handleGoNext}>
            Yes, please email me
          </NsPrimaryCta>
        </NsContent>
        <NsColumn
          basketballcourt="1"
          hockeypitch="2"
          footballpitch="2"
          rugbypitch="2"
          polofield="2"
        >
          <NsCard
            type="support"
            heading="Already a British Gas customer?"
            action={
              <NsSecondaryCta href={actionUrl.login} testId="loginLinkTestId">
                Login to your account
              </NsSecondaryCta>
            }
          >
            You can easily browse all the tariffs available for you in your
            online account.
          </NsCard>
        </NsColumn>
      </NsPanel>
    </Feature>
  );
};

export default BusinessAnnouncement;
